import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import router from './router/index.js'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);
Vue.use(VueYandexMetrika, {
  id: 91201993,
  router: router,
  env: process.env.NODE_ENV
  // other options
})

new Vue({
  vuetify,
  VueYandexMetrika,
  router,
  render: h => h(App)
}).$mount('#app')
